import React from "react";
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalText,
  ButtonsContainer,
  AcceptButton,
  DeclineButton,
} from "./styled";

const AgeVerificationModal = ({ onAccept, onDecline, show }) => {
  if (!show) {
    return null;
  }

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>Weryfikacja wieku</ModalHeader>
        <ModalText>
          Aby korzystać z naszej aplikacji, musisz mieć ukończone 18 lat.
        </ModalText>
        <ModalText>
          Czy potwierdzasz, że masz ukończone 18 lat?
        </ModalText>
        <ButtonsContainer>
          <AcceptButton onClick={onAccept}>
            Tak, mam ukończone 18 lat
          </AcceptButton>
          <DeclineButton onClick={onDecline}>
            Nie, nie mam 18 lat
          </DeclineButton>
        </ButtonsContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default AgeVerificationModal;

